import "./form-registration.scss";

import { RegistrationFormSchema } from "@factory/form/form.rule";
import { GetTenantModel } from "@factory/model/query-model-tenant";
import { useQyGetTenantBySlug } from "@factory/query/tenant.query";
import ImageControl from "@shared/ui/hook-form/image-control/image-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputOptControl from "@shared/ui/hook-form/input-opt-control/input-control";
import TextBlock from "@shared/ui/text-block/text-block";
import { calculateAge } from "@shared/utility/calculage-age";
import { Divider } from "primereact/divider";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useParams, useSearchParams } from "react-router-dom";

import { appFeature } from "../../../app.feature";

type InputFormSchema = RegistrationFormSchema;
export function FormRegistration() {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('referral');
  const [disableReferral, setDisableReferral] = useState(false);

  const { control, setValue } = useFormContext<RegistrationFormSchema>();
  const customerPasscodeLength = appFeature.config.password.pinLength ?? 6;
  const [calculatedAge, setCalculatedAge] = useState<number | null>(null);

  const { tenantSlug } = useParams();
  const { data: tenantResponse } = useQyGetTenantBySlug(tenantSlug || "");
  const tenantData = tenantResponse?.data as GetTenantModel;

  useEffect(() => {
    if (referralCode) {
      setDisableReferral(true);
      setValue("referralCode", referralCode);
    }
  }, [])

  return (
    <div id="FormRegistration" className="registration">
      <ImageControl<InputFormSchema>
        control={control}
        name="photo"
        label="Person Photo"
        imagePreviewClass="w-32 h-32"
      />
      <Divider />
      {tenantData?.feature_referral ? (
        <InputControl<InputFormSchema>
          control={control}
          name="referralCode"
          label="Referral Code (Optional)"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter referral code"
          disabled={disableReferral}
        />
      ) : null}
      <InputControl<InputFormSchema>
        control={control}
        name="firstName"
        label="First Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter firstName"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="lastName"
        label="Last Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter lastName"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="birthday"
        label="Birthday"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        onChange={(value: string) => {
          const age = calculateAge(value);
          setCalculatedAge(age);
        }}
      />
      <TextBlock
        label="Age"
        value={calculatedAge !== null ? calculatedAge.toString() : undefined}
        mode="horizontal"
        className="w-full pb-2 my-4"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="email"
        label="Email"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter email"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="mobileNumber"
        label="Mobile Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter mobileNumber"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="username"
        label="Username"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter username"
      />
      <InputOptControl<InputFormSchema>
        control={control}
        name="password"
        label="Passcode"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        mask={true}
        integerOnly={true}
        length={customerPasscodeLength}
      />
    </div>
  );
}

export default FormRegistration;
